import { ReactElement } from "react";
import classNames from "classnames";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./FeaturedBanner.module.less";

type FeaturedBannerKind =
	| "new"
	| "beta"
	| "primary";

export type FeaturedBannerProps = {
	size?: "default" | "large";
} & (
		{
			kind: Exclude<FeaturedBannerKind, "primary">;
		}
		|
		{
			kind: "primary";
			text: string;
		}
	);

export const FeaturedBanner = (props: FeaturedBannerProps): ReactElement => {
	const {
		size = "default",
		kind
	} = props;

	return (
		<div
			className={classNames(
				styles.root,
				{ [styles.root_large]: size === "large" }
			)}
		>
			<span
				className={classNames(
					styles.text,
					kindToStyleMap[kind]
				)}
			>
				{props.kind === "primary"
					? props.text
					: kindToTextMap[props.kind]
				}
			</span>
		</div>
	);
};
FeaturedBanner.displayName = "FeaturedBanner";

const kindToStyleMap: Record<FeaturedBannerKind, string> = {
	["new"]: styles.text_new,
	["beta"]: styles.text_beta,
	["primary"]: styles.text_primary
};

const kindToTextMap: { [key in Exclude<FeaturedBannerKind, "primary">]: string; } = {
	new: localize("_New"),
	beta: "Beta"
};
